import React from "react";
import "./CaisseP.css";

export default function CaisseP() {
  return (
    <div className="caisse-container">
      {/* <p className="caisse-policy">
        Suivez ces étapes pour <strong>"Payer votre commande à la caisse"</strong>, Envoyez toujours une capture de la preuve sur le <strong>+228 90 04 59 26</strong>{" "}
        .
      </p> */}

      <div className="caisse-info-box">
        {/* <h3 className="caisse-info-title">TOGO</h3>
        <p className="caisse-info-text">Mixx By Yas: <strong>*145*5*Montant*1089835#</strong></p>
        <p className="caisse-info-text">Flooz: <strong>*155*2*2*22879321160*22879321160*Montant#</strong></p>

        <hr className="caisse-divider" /> */}

        <h3 className="caisse-info-title">Ecrivez nous</h3>
        <p className="caisse-info-text">Envoyez toujours le reçu de paiement sur <strong>+228 90 04 59 26</strong> avec le numéro de la commande.</p>
        <hr className="caisse-divider" />
      </div>
      
    </div>
  );
}